import CircularProgress from "@material-ui/core/CircularProgress";
import * as React from "react";

export const LoadingOverlay = (props: { delayMs?: number }) => {
    const [show, setShow] = React.useState(false);
    React.useEffect(() => {
        const timeout = setTimeout(() => setShow(true), props.delayMs ?? 0);
        return () => clearTimeout(timeout);
    }, [props.delayMs]);

    if (!show) {
        return null;
    }

    return (
        <div
            style={{
                display: "flex",
                position: "fixed",
                width: "100%",
                height: "100%",
                alignItems: "center",
                justifyContent: "center",
                left: 0,
                top: 0,
                zIndex: 9999,
                background: "rgba(0, 0, 0, .5)"
            }}
        >
            <CircularProgress color="primary" />
        </div>
    );
};
